module.exports = __webpack_public_path__ + "media/static/icons/icon-reef--green-61d04de6084b9c207afdc3d3c92afbc9.svg";